import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { ProductCategoryService } from '../../data-access/productCategory.service';
import { Subject, takeUntil } from 'rxjs';
import { FormGroup, FormControl, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ProductCategory } from '../../interfaces/productCategory.interface';

@Component({
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CommonModule,
    FormsModule
  ],
  providers: [
    ProductCategoryService
  ],
  selector: 'equine-ui-nx-product-category-admin',
  templateUrl: './product-category-admin.component.html',
  styleUrls: ['./product-category-admin.component.css']
})
export class ProductCategoryAdminComponent implements OnInit, OnDestroy {

  #productCategoryService = inject(ProductCategoryService);
  unsubscribe$ = new Subject<void>();
  id = '';
  form: FormGroup;
  productCategories: ProductCategory[] = [];
  showProductCategories: boolean = false;

  constructor() {
    this.form = new FormGroup({
      name: new FormControl('', Validators.required),
      description: new FormControl(''),
      active: new FormControl('true', Validators.required)
    });
  }

  createNew() {
    if (this.form.valid) {
      const formValue= {
        ...this.form.value,
        active: this.form.value.active === 'true'
      };

      this.#productCategoryService.create(formValue)
        .pipe(
          takeUntil(this.unsubscribe$)
        )
        .subscribe({
          next: (response) => {
            this.id = response.id;
            if (this.showProductCategories) {
              this.fetchProductCategories();
            }
          }
        });
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  ngOnInit() {
    this.fetchProductCategories();
  }

  fetchProductCategories() {
    this.#productCategoryService.getAll()
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe({
      next: (productCategories) => this.productCategories = productCategories
    });
  }

  toggleShowProductCategories() {
    this.showProductCategories = !this.showProductCategories;
    if (this.showProductCategories) {
      this.fetchProductCategories();
    }
  }

  editProductCategory(productCategory: ProductCategory) {
    productCategory.isEditing = true;
  }

  cancelEditing(productCategory: ProductCategory) {
    productCategory.isEditing = false;
  }

  updateProductCategory(productCategory: ProductCategory) {
    if (!productCategory.isEditing) return;
    const updatedProductCategory = {
      name: productCategory.name,
      description: productCategory.description,
      active: productCategory.active
    };
    this.#productCategoryService.update(productCategory.id, updatedProductCategory)
      .subscribe({
        next: () => {
          productCategory.isEditing = false;
          this.fetchProductCategories();
        }
      });
  }

  deleteProductCategory(id: string) {
    this.#productCategoryService.delete(id).subscribe(() => {
      this.fetchProductCategories();
    });
  }
}
